var _excluded = ["total", "className", "style", "showTotal", "defaultPageSize", "showQuickJumper", "position", "paginationClassName", "defaultCurrent"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import useZhCNLocale from "../hooks/useZhCNLocale";
import { Pagination as AntdPagination } from 'antd';
import cx from 'classnames';
import { isBoolean, isUndefined } from 'lodash-es';
import React, { useCallback, useMemo } from 'react';
import "./style/index.css";
var Pagination = function Pagination(props) {
  var _useZhCNLocale = useZhCNLocale(),
    locale = _useZhCNLocale.locale;
  var _props$total = props.total,
    total = _props$total === void 0 ? 0 : _props$total,
    className = props.className,
    style = props.style,
    showTotal = props.showTotal,
    defaultPageSize = props.defaultPageSize,
    showQuickJumper = props.showQuickJumper,
    _props$position = props.position,
    position = _props$position === void 0 ? 'right' : _props$position,
    paginationClassName = props.paginationClassName,
    defaultCurrent = props.defaultCurrent,
    otherProps = _objectWithoutProperties(props, _excluded);
  var isRenderTotal = useMemo(function () {
    return !(isUndefined(showTotal) || isBoolean(showTotal) && !showTotal);
  }, [showTotal]);
  var renderTotal = useCallback(function (page, range) {
    if (isUndefined(showTotal) || isBoolean(showTotal) && !showTotal) {
      return undefined;
    }
    if (isBoolean(showTotal) && showTotal) {
      return "\u5171".concat(total, "\u6761\u6570\u636E");
    }
    return showTotal(page, range);
  }, [total, showTotal]);
  return /*#__PURE__*/React.createElement("div", {
    className: cx('dr-pagination-wrapper', className, "dr-pagination-wrapper-".concat(position), isRenderTotal && 'dr-pagination-total'),
    style: style
  }, /*#__PURE__*/React.createElement(AntdPagination, _extends({
    locale: locale.Pagination
  }, otherProps, {
    showTotal: function showTotal(page, range) {
      return renderTotal(page, range);
    },
    defaultCurrent: defaultCurrent || 1,
    defaultPageSize: defaultPageSize || 10,
    showQuickJumper: isUndefined(showQuickJumper) ? true : showQuickJumper,
    total: total,
    className: cx(paginationClassName, 'dr-pagination__inner')
  })));
};
export default Pagination;